import React, { Component } from "react";
import { WingBlank } from "antd-mobile";
import { createForm } from "rc-form";
import get from "lodash/get";
import styled from "styled-components";
import { needleImageCdnStart } from "../../../utils/index";

export class CommentFIxed extends Component {
  render() {
    const screenBottom = get(this.props, "isBigScreen") ? 34 : 0;
    return (
      <div
        style={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          // height: screenBottom + 50 + "px",
          zIndex: 1,
          background: "rgb(248,247,248)",
        }}
      >
        <WingBlank
          size="lg"
          style={{
            margin: "5px 15px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <InputView>
            <div
              className="input-container"
              onClick={(e) => this.props.clickShowInput()}
              style={{
                display: "flex",
              }}
            >
              <img
                style={{
                  width: 20,
                  height: 20,
                  marginRight: 4,
                }}
                src={needleImageCdnStart("WFq_U1VZI.png")}
              />
              <span
                style={{
                  color: "#999999",
                  fontSize: 15,
                  lineHeight: "24px",
                }}
              >
                您想说点什么...
              </span>
            </div>
          </InputView>
        </WingBlank>
      </div>
    );
  }
}

const InputView = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #ffffff;
  // border-top: 1px solid rgba(234, 234, 234, 1);
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.1);
  padding: 10px;
  .input-container {
    position: relative;
    background: #f5f6f8;
    padding: 10px;
    border-radius: 5px;
    color: rgba(153, 153, 153, 1);
    dispaly: flex;
    align-items: center;
  }
`;
// export default createForm()(CommentFIxed)



// WEBPACK FOOTER //
// ./src/modules/knowledge/components/commentFIxed.js